import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { ApiError } from '../api/client';

export const meQueryKey = ['me'] as const;

// Abgelaufene Sitzungen (401) führen global zurück zum Login, unabhängig davon,
// welche Anfrage den Fehler ausgelöst hat.
export function createQueryClient(options: { retry?: boolean } = {}): QueryClient {
  const onError = (error: unknown) => {
    if (error instanceof ApiError && error.isUnauthorized) client.setQueryData(meQueryKey, null);
  };
  const client: QueryClient = new QueryClient({
    queryCache: new QueryCache({ onError }),
    mutationCache: new MutationCache({ onError }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: options.retry === false ? false : (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
      },
    },
  });
  return client;
}
